<template>
  <div class="table-actions">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'table-actions',
};
</script>

<style lang="scss" scoped>
.table-actions {
  display: flex;
  justify-content: flex-end;
}
</style>
